export default [
  {
    title: 'GENERAL',
    details: [
      {
        description:
          'The Schedulized Platform is operated by Redelec Pty Ltd (ACN 614 350 613) (<b>Redelec</b>, <b>we</b>, <b>our</b> or <b>us</b>).'
      },
      {
        description:
          'By using, browsing or accessing the Schedulized Platform and the Services, you acknowledge that you have read, understood and accept these Authorised User Terms and Conditions (<b>agreement</b>), together with our Privacy Policy, and agree to abide by them. If you do not accept this agreement, you must not access and use the Schedulized Platform, and you will not be able to access or otherwise use Content provided by the Schedulized Platform to users.'
      },
      {
        description:
          'In this agreement, <b>User</b>, <b>you</b> and <b>your</b> means the person authorised by the Customer to access and use the Schedulized Platform, and whose details are listed in the User Account (and includes anyone acting on your behalf or with your express or implied authority).'
      }
    ]
  },
  {
    title: 'REGISTRATION AND ACCESS',
    details: [
      {
        description: 'To access and use the Schedulized Platform, you must:',
        details: [
          'register with us and setup an account (<b>User Account</b>). Your User Account will be operated by a username and password (<b>User Password</b>) which can be changed any time by you accessing the settings page on the Schedulized Platform. To setup a User Account and to create a profile on the Schedulized Platform, you will be required to provide Personal Information to us; and',
          'be over 18 years of age, and legally able to enter into contractual relations. If you are under the age of 18 years (<b>Minor</b>) you must immediately cease and refrain from accessing or using the User Account and/or the Schedulized Platform. Your continued use of the User Account constitutes an acknowledgement by you that you are over 18 years of age.'
        ]
      },
      {
        description: 'You are responsible for:',
        details: [
          'maintaining control over, and the confidentiality of any User Account, and User Password;',
          'keeping your User Account registration information current, complete, accurate, and truthful. You must not impersonate another account holder or provide false identity information to gain access to or use the Schedulized Platform or User Account;',
          'notifying us in writing of any unauthorised access to, or use of, your User Account or User Password; and',
          'for all activities or transactions that occur using your User Account. We are not liable for any loss or damage arising out of, or in connection with, any unauthorised access or use of, your User Account and User Password. '
        ]
      }
    ]
  },
  {
    title: 'TERM',
    description:
      'This agreement will commence on the date you download the Schedulized Platform and continues until it is terminated in accordance with clause 13.'
  },
  {
    title: 'YOUR OBLIGATION ',
    description:
      'This agreement will commence on the date you download the Schedulized Platform and continues until it is terminated in accordance with clause 13.',
    details: [
      {
        description:
          'Subject to the terms of this agreement, we grant you a non-exclusive, personal, revocable, non-transferable and non-sub-licensable licence to access and use the Schedulized Platform and the Services. You must only use the Schedulized Platform for business purposes, and for the exclusive benefit of the Customer. '
      },
      {
        description:
          'You will not acquire, or be entitled to, any rights other than those rights expressly set out in this agreement.'
      },
      {
        description:
          'When using the Schedulized Platform and the Services, you must at all times:',
        details: [
          'obtain and maintain all hardware, software and communications equipment necessary to access, and use the Schedulized Platform and the Services;',
          'comply with all Relevant Laws with respect to your obligations under this agreement; and',
          'comply with all of our directions, policies and guidelines, advised in writing to you or posted on the Schedulized Platform from to time to time. '
        ]
      },
      {
        description:
          'We will not be liable to you or anyone else if, for any reason, the Schedulized Platform or the Services are unavailable at any time or for any period. From time to time, we may suspend or restrict access to all, or some parts of the Schedulized Platform or the Services. You are responsible for making all arrangements necessary for you to access and use the Schedulized Platform and the Services. You are also responsible for ensuring that all persons who access the Schedulized Platform or the Services (such as through your internet connection, mobile phone, computer or any other device) are aware of this agreement, and that they comply with them.'
      },
      {
        description: 'You must not:',
        details: [
          'introduce, access, store, distribute or transmit any viruses, worm, trojan or other malicious code into the Schedulized Platform;',
          'violate any Redelec IP or any third party Intellectual Property Rights;',
          'copy, modify, duplicate, create derivative works from, frame, mirror, republish, transmit or distribute all or any portion of the Schedulized Platform, or any other third party software that you may access or use through the Schedulized Platform, in any way; ',
          'access all or any part of the Schedulized Platform or the Services in order to build a product, service or code which competes or reproduces the Schedulized Platform or the Services (in full or part); ',
          'modify, alter, adapt, reverse compile, disassemble, reverse engineer or otherwise reduce to human-perceivable form all or any part of the Schedulized Platform in any way, or otherwise learn the source code or algorithms underlying the Schedulized Platform; ',
          'license, sell, rent, lease, transfer, assign, distribute, display, disclose, or otherwise commercially exploit, or otherwise make the Schedulized Platform or the Services available to any third party or other person who is not a User; and ',
          'engage in any activity or conduct that is in breach of any Relevant Laws.  '
        ]
      }
    ]
  },
  {
    title: 'USER DATA',
    details: [
      {
        description:
          'The Schedulized Platform is a platform or conduit that allow Customers and User to:',
        details: [
          'view, create, upload and amend; ',
          'track, store and transmit; ',
          'manage projects and compliance reminders; and ',
          'communicate and share; '
        ],
        descriptionAfter:
          'electrical switchboard information including: names, circuit schedules, board locations, cabling sizes, metering, account numbers and thermal imaging data as further described on the Website (collectively, <b>User Data</b>).'
      },
      {
        description:
          'We are not responsible for monitoring or censoring the User Data. However, we reserve our rights to remove or alter the User Data stored on the Schedulized Platform without providing you with notice if we consider that any User Data does not comply with this agreement. '
      },
      {
        description:
          'We do not recommend or endorse any products, services, or User Data published, shared, created or uploaded on, or via, the Schedulized Platform. We disclaim all liability and responsibility arising from any reliance placed on such User Data. We make no representations or warranties that any use of the User Data will not infringe Intellectual Property Rights of any third parties.  '
      },
      {
        description:
          'You agree to make your own enquiries to verify information displayed on, or via, the Schedulized Platform to assess the suitability of any information before relying upon such information. If you choose to rely upon any information uploaded or displayed, or listed on the Schedulized Platform, you do so at your own risk.'
      }
    ]
  },
  {
    title: 'BACK-UP OF USER DATA',
    details: [
      {
        description:
          'In the event of any loss to User Data, the User’s sole and exclusive remedy will be for Redelec to use reasonable endeavours to restore the User Data, that is lost or damaged.'
      },
      {
        description:
          'We will not be responsible for any loss, destruction, alteration, corruption or disclosure of Customer Data caused by an act or omission of you, the Customer, any other user, any third party, or a Force Majeure Event.'
      }
    ]
  },
  {
    title: 'INTELLECTUAL PROPERTY RIGHTS ',
    details: [
      {
        description:
          'You acknowledge that we and our licensors, are the owners of the Schedulized Platform (or any Intellectual Property Rights contained within the Schedulized Platform) including any information, technology software, solution or the Services that may be provided to, or accessed by, you in connection with your use of the Schedulized Platform (including any modifications, enhancements of the foregoing (Redelec IP). Accessing and using the Schedulized Platform does not give you (or anyone else) ownership of, or any right, title or interest in the Redelec IP. '
      },
      {
        description:
          'Ownership of any User Data which is uploaded or transmitted on, via or through the Schedulized Platform will vest in the Customer. '
      },
      {
        description:
          'Without limiting clause 7.2, you grant us a worldwide, non-exclusive, royalty-free, perpetual, non-transferable licence to use, disclose, reproduce, store, distribute, publish, export, adapt, edit, translate, produce derivative works from or copy any User Data (and all Intellectual Property Rights contained within) for the purpose of:',
        details: [
          'enabling us to provide you with access to, and use of the Schedulized Platform and the Services, and otherwise perform our obligations and exercise our rights under this agreement;  ',
          'informing you of products, services or events that we may offer from time to time or in relation to Third Party Products;',
          'identifying usage patterns, trends, and other statistical or behavioural data derived from use of the Schedulized Platform and the Services, in aggregated anonymized form, for the purposes of providing, operating, maintaining, or improving the Schedulized Platform and the Services and for marketing purposes as further described in our Privacy Policy; and',
          'sharing User Data with an Affiliate or other third party (with whom we may contract or be affiliated with from time to time) for the purposes of performing or improving the Schedulized Platform and the Services.'
        ]
      }
    ]
  },
  {
    title: 'OUR OBLIGATIONS',
    details: [
      {
        description:
          'Subject to your compliance with the terms of this agreement, we will use reasonable endeavours to provide you with access to and use of the Schedulized Platform and the Services. '
      },
      {
        description:
          'In the event that we fail to provide you with access and use of the Schedulized Platform and the Services accordance with clause 8.1, we shall use reasonable endeavours to correct any such non-conformance, or provide you with an alternative means of accomplishing the desired performance. The foregoing constitutes your sole and exclusive remedy for any breach of clause 8.1.'
      }
    ]
  },
  {
    title: 'FEES',
    details: [
      {
        description:
          'The User will not be charged to access and use the Schedulized Platform. '
      },
      {
        description:
          'We may charge you a fee to access and use the Schedulized Platform and the Services (<b>User Fee</b>) (or if we are already charging you a User Fee, to increase the User Fee) at any time upon 30 days’ written notice to you. If you do not agree to these changes, you may terminate the agreement by written notice to the us no later than 14 days after the date you received the written notice from us.'
      }
    ]
  },
  {
    title: 'NO WARRANTIES',
    details: [
      {
        description:
          'To the maximum extent permitted by Relevant Laws, we exclude all express or implied representations, conditions, statutory guarantees, warranties and provisions (whether based on statute, common law or otherwise), in connection with the Schedulized Platform.'
      },
      {
        description:
          'Nothing contained in this agreement excludes, restricts or modifies the application of any condition, warranty or other obligation, the exercise of any right or remedy, or the imposition of any liability under the Competition and Consumer Act 2010 (Cth) or any other national, State or Territory legislation where to do so is unlawful. '
      },
      {
        description:
          'You acknowledge, and agree that to the maximum extent permitted by Relevant Laws, we make no representation, warranty or guarantee in relation to the availability, continuity, reliability, accuracy, currency or security of the Schedulized Platform or the Services (or any User Data, products or services provided in connection with the Schedulized Platform) and we will not be liable if the Schedulized Platform or the Services are, or becomes unavailable for any reason, including directly, or indirectly as a result of:',
        details: [
          'telecommunications unavailability, interruption, delay, bottleneck, failure or fault;',
          'suspension of access to the Schedulized Platform due to non-payment of any Fees which remain outstanding and owing to us by the Customer; ',
          'negligent, malicious, wilful acts or omissions of third parties (including third party service providers) or other users;',
          'maintenance (scheduled or unscheduled) carried out by us or any third party service provider, including in respect of any of the systems or network used in connection with the provision of the Schedulized Platform;',
          'services provided by third parties (including internet service providers) ceasing or becoming unavailable; or',
          'a Force Majeure Event.'
        ]
      },
      {
        description:
          'You acknowledge that, to the maximum extent permitted by Relevant Laws, we do not make any warranty or representation:',
        details: [
          'that any information uploaded or made available to you, by the Customer, us or another user of the Schedulized Platform (including any User Data), including any Content made available or offered on, or via the Schedulized Platform is accurate, complete, reliable, current or error-free, virus free or is suitable for any particular purpose or use under any specific conditions, and so is provided on an “as is” basis; and ',
          'as to the existence, quality, legality, or availability of the services or products that may be offered, listed or published on, by way of, or via, the Schedulized Platform or the Services. '
        ]
      },
      {
        description:
          'You acknowledge that your access to, and use of, the Schedulized Platform and the Services may be interrupted or unavailable during scheduled or unscheduled maintenance.'
      }
    ]
  },
  {
    title: 'LIMITATION OF LIABILITY',
    details: [
      {
        description:
          'To the maximum extent permitted by Relevant Laws, we will not be liable to you, the Customer or any third party for:',
        details: [
          'direct, indirect, consequential, incidental, special or exemplary damages, expenses, losses or liabilities;',
          'loss of profits, business interruption, loss of revenue, economic loss, loss of goodwill, loss of or corruption to data, downtime costs, loss of use, any failure to realise anticipated savings, loss of opportunity or expectation loss, or loss of production; or',
          'loss of, or damage to, any property or any personal injury or death to you or any third person,'
        ],
        descriptionAfter:
          'arising out of relating or connected to, the provision or use of the Schedulized Platform or the Services (including any User Data, products or services provided in connection with the Schedulized Platform) and this agreement, regardless of the cause of action on which they are based, even if advised of the possibility of such damage occurring. '
      },
      {
        description:
          'All risk in using the Schedulized Platform passes to you upon creating a User Account, or otherwise using the Schedulized Platform or the Services (whichever is earlier) through a User Account. We do not control or direct what User Data is uploaded, shared, published, posted or otherwise transmitted by users on, or via, the Schedulized Platform, and we are not responsible to you, the Customer or anyone else for any actions, activities, conduct or transactions (whether online or offline) that occur as a result of, or in connection with your access to, and use of, the Schedulized Platform or the Services. '
      },
      {
        description:
          'To maximum extent permitted by Relevant Laws, under no circumstances will our aggregate liability to you or anyone else, whether based upon warranty, contract, statute, tort (including negligence) or otherwise, exceed one hundred dollars (AUD $100).'
      },
      {
        description:
          'You agree to defend, indemnify and hold us, our Affiliates and our Personnel (collectively, the <b>Indemnified</b>) harmless from and against any and all actions, claims, proceedings, demands, liabilities, losses, damages, expenses and costs (including legal costs on a full indemnity basis) that may be brought against the Indemnified or which the Indemnified may pay, sustain or incur as a direct or indirect result of or arising out of:',
        details: [
          'your access to, and use of, or reliance on User Data or any products or services acquired on, or via, the Schedulized Platform or the Services;',
          'the use by you, your Personnel or any third party of the Schedulized Platform or the Services; ',
          'any breach of any third party’s Intellectual Property Rights or other rights caused by you; or',
          'any breach by you or your Personnel of this agreement.'
        ]
      }
    ]
  },
  {
    title: 'THIRD PARTY PRODUCTS',
    details: [
      {
        description:
          'You acknowledge that we may use Third Party Providers to enable us to provide you with access to, and use of, the Schedulized Platform and the Services, and that your use of and reliance on it, is solely at your own risk.'
      },
      {
        description:
          'We do not endorse, sponsor or approve any Third Party Products or Third Party Providers made available on or via the Schedulized Platform. It is your sole responsibility to determine that specific products or services used by you which may be offered through the Schedulized Platform, meet your needs and/or are suitable for the purposes for which they are used.'
      },
      {
        description:
          'Any rights you may have to access Third Party Products or Third Party Providers shall be limited to: ',
        details: [
          'the extent of our ability to pass on such rights to you; or ',
          'the relevant Third Party Provider’s terms. '
        ]
      }
    ]
  },
  {
    title: 'PRIVACY',
    description:
      'All Personal Information you provide to open a User Account and any User Data you upload, share, or publish on, or via, the Schedulized Platform, is subject to our Privacy Policy, which is incorporated into this agreement. You warrant that, in relation to any Personal Information comprising User Data or any other information disclosed to us on, or via, the Schedulized Platform:',
    details: [
      {
        details: [
          'it has been collected in accordance with Privacy Laws; ',
          'you have the authority to upload, post, publish or otherwise transmit such information on, or via, the Schedulized Platform; and',
          'you have obtained the informed consent of the individuals who are the subject of such Personal Information in order for us to use, disclose, store, transfer, process or handle it. '
        ]
      }
    ]
  },
  {
    title: 'TERMINATION',
    details: [
      {
        description:
          'We may terminate this agreement (without liability to you) at any time by providing you with 1 days’ written notice. '
      },
      {
        description: 'The User may terminate this agreement at any time:',
        details: [
          'by deleting the Schedulized Platform, if the User is using the Schedulized Platform free of charge; or',
          'providing us with [insert eg 7] days’ written notice, if the User is being charged a fee to access and use the Schedulized Platform. '
        ]
      },
      {
        description:
          'If the agreement is terminated by either party in accordance with clause 14, there is no pro rata refund of the unused User Fees (if any).'
      },
      {
        description:
          'You agree that we may, at any time and at our sole discretion, with or without cause or any notice to you, terminate, suspend or block your access to (either temporarily or permanently):',
        details: [
          'your User Account or User Password; ',
          'Schedulized Platform; and/or',
          'any events, social media page, networks, products and services offered on, or via the Schedulized Platform.'
        ]
      },
      {
        description:
          'Cause for such suspension or termination may include, but are not be limited to:',
        details: [
          'serious or repeated breaches or violations of another person’s Intellectual Property Rights or privacy rights;',
          'termination by the Customer or Redelec of the Redelec SaaS Agreement for any reason;',
          'your activities, conduct or transactions on, or, via, the Schedulized Platform, which bring, or which has the capacity to bring Redelec into disrepute; ',
          'any alteration, modification, manipulation of any User Data without the consent of the owner of the User Data (ie. construction and project information); and ',
          'requests by law enforcement or other government agencies. '
        ]
      },
      {
        description:
          'You agree that all such suspensions or terminations shall be made at our sole discretion and that we shall not be liable to you, the Customer or any third party for any such suspension or termination.'
      },
      {
        description: 'Upon termination of this agreement for any reason:',
        details: [
          'you must return any Redelec IP in your possession; and',
          'all licences to use the Schedulized Platform and rights granted under this agreement will terminate from the effective date of termination.'
        ]
      }
    ]
  },
  {
    title: 'FORCE MAJEURE',
    description:
      'We shall not be responsible to you or the Customer (or anyone else) if we are prevented from or delayed in performing our obligations, by acts, events, omissions or accidents beyond our reasonable control, including but not limited to, acts of God, governmental actions, shipping, postal or other relevant transport strikes, failure or accident, lockouts or other labour difficulty, war or national emergency, acts of terrorism, fires, explosion, flood, epidemic, pandemic, mandatory government lock-down, any acts or omissions of a third party; shortage of or inability to obtain any necessary materials, equipment, facilities or services, internet interruption, accidents or breakdown of plant, machinery, software, hardware or communication network, or any default of hosting or data centre providers (<b>Force Majeure Event</b>).'
  },
  {
    title: 'UPDATES AND VARIATIONS',
    details: [
      {
        description:
          'Without notice to you, we may, at out absolute discretion, from time to time',
        details: [
          'change, add or delete the functions, features, performance, or other characteristics to the Schedulized Platform; or',
          'apply or install updates to, or new versions of, the Schedulized Platform.'
        ]
      },
      {
        description:
          'You acknowledge that the Content on the Schedulized Platform is subject to change at any time and may be out of date at any given time. Unless otherwise agreed in the Redelec SaaS Agreement, we are under no obligation to:',
        details: [
          'provide any user support services, update, correct or fix any Content or the Schedulized Platform; or',
          'notify you of any changes to the Content or to the Schedulized Platform unless required by law to do so. '
        ]
      },
      {
        description:
          'Some of the provisions contained in this agreement may also be superseded by provisions or notices published elsewhere on the Schedulized Platform. Any changes are effective immediately upon posting to the Schedulized Platform. Your continued use of the Schedulized Platform constitutes your acceptance of all such changes to the agreement. '
      },
      {
        description:
          'Please read this agreement before using the Schedulized Platform or the Services as the agreement may have changed since the last time you accessed and used the Schedulized Platform or the Services. If you do not agree to any change, then you must immediately stop using the Schedulized Platform and the Services.'
      }
    ]
  },
  {
    title: 'SEVERABILITY',
    description:
      'If any provision in this agreement is found to be invalid or unenforceable by a court of law, such invalidity or unenforceability will not affect the reminder of this agreement which will continue in full force and effect.'
  },
  {
    title: 'RELATIONSHIP',
    description:
      'No agency, principal-agent, partnership, joint venture, employee-employer or franchisor-franchisee relationship is intended or created, between you and us by this agreement.'
  },
  {
    title: 'INCONSISTENCY',
    description:
      'If there is any inconsistency between the terms of this agreement and the terms of the Redelec SaaS Agreement, the terms of the Redelec SaaS Agreement will prevail to the extent of the inconsistency.'
  },
  {
    title: 'ENTIRE AGREEMENT',
    description:
      'This agreement, any other documents referred to in it, represent the entire agreement between us and you in relation to the subject matter and supersedes any previous arrangements, agreements, representations, understandings or statements (whether verbal, in writing, or in some other format).'
  },
  {
    title: 'JURISDICTION AND APPLICABLE LAW',
    details: [
      {
        description:
          'The Schedulized Platform is created and controlled by us in the State of New South Wales, Australia. As such, the laws of the State of New South Wales will govern this agreement. '
      },
      {
        description:
          'By using the Schedulized Platform and the Services you submit to the exclusive jurisdiction of the courts of New South Wales, and agree that any legal action will only be commenced in this forum. '
      }
    ]
  },
  {
    title: 'DEFINITIONS',
    description:
      'In this agreement, the following words shall have the following meanings',
    details: [
      {
        description:
          'Affiliate means in relation to any party, a person which, directly or indirectly, (i) is Controlled by that party; or (ii) Controls that party; or (iii) is Controlled by a person referred to in (ii) above, and for this purpose Control means the power of a person to secure (whether by the holding of shares, possession of voting rights or by virtue of any powers conferred by articles of association, constitution, partnership agreement or other document regulating such person) that the affairs of another are conducted in accordance with its wishes.'
      },
      {
        description:
          '<b>agreement</b> has the meaning in clause 1.2 of this agreement.'
      },
      {
        description:
          '<b>App</b> has the meaning given to it by the Redelec SaaS Agreement.'
      },
      {
        description:
          '<b>Content</b> means all the information, text, materials, graphics, logos, button icons, images, video and audio clips, trade marks (whether registered or not), advertisements, layout, arrangement, graphical user interface, look and feel, databases, functionality and control features of the Schedulized Platform.'
      },
      {
        description:
          '<b>Customer</b> means the person or entity who has been granted a licence to access and use the Schedulized Platform and the Services in accordance with Redelec SaaS Agreement.'
      },
      {
        description:
          '<b>Customer Password</b> has the meaning given to it by the Redelec SaaS Agreement; '
      },
      {
        description: '<b>Force Majeure</b> Event has the meaning in clause 14.'
      },
      {
        description:
          '<b>Intellectual Property Rights</b> means designs, copyright, trade marks, patents, operations, software or systems, trade names and domain names, rights in goodwill, rights in confidential information or other intellectual property rights, whether under statute, common law, equity, and whether registered or unregistered, and including all applications for, and renewals or extensions of, such rights and all similar rights which subsist or will subsist now or in future in any part of the world.'
      },
      {
        description:
          '<b>Personnel</b> means any person acting for or on behalf of a party and includes any director, officer, employee, agents, advisors, consultants or contractors, of that party. '
      },
      {
        description:
          "<b>Personal Information</b> means data by which a person may be personally identified, including a person's name, postal address, email address, telephone number and any other information a party collects, including that which is defined as personal or personally identifiable information under any applicable Privacy Laws."
      },
      {
        description:
          '<b>Privacy Laws</b> means any applicable laws and codes of practice dealing with privacy, including the Privacy Act 1988 (Cth) (as amended) and the Australian Privacy Principles, and any other legislation, codes and policies relating to the handling of Personal Information applicable to the jurisdiction in which the user is located. '
      },
      {
        description:
          '<b>Privacy Policy</b> means our privacy policy available at [insert link to website] or any other internet site notified by us from time to time, which is incorporated into this agreement.'
      },
      {
        description:
          '<b>Relevant Laws</b> means any relevant rules of common law, principles of equity, international, federal, state and local laws, statutes, rules, regulations, proclamations, ordinances and by-laws and other subordinate legislation, rulings, or legal requirements and Privacy laws, anywhere in the world. '
      },
      {
        description:
          '<b>Redelec IP</b> has the meaning given to it by clause 7.1. '
      },
      {
        description:
          '<b>Redelec Agreement</b> means the Software-as-a Service Subscription Agreement between Redelec and the Customer. '
      },

      {
        startNew: true,
        description:
          '<b>Schedulized Platform</b> means the platform made available through the Website and App which is owned, operated and managed by us, including any systems, Content and server software, the computer hardware on which the platform, application, database, system, Content and server software is installed, and all Intellectual Property contained within, provided or otherwise made available by us.'
      },
      {
        description:
          '<b>Services</b> means the subscription services made available to you in accordance with the SaaS Agreement and this agreement, which subscription relates to the downloading, accessing and/or using of the Schedulized Platform (through the App and/or Website)  for the purpose of',
        roman: true,
        details: [
          'viewing, creating, uploading and amending; ',
          'tracking, storing and transmitting; ',
          'managing projects and compliance reminders; and ',
          'communicating and sharing, '
        ],
        descriptionAfter: 'any User Data stored on the Schedulized Platform.'
      },
      {
        description:
          '<b>Term</b> has the meaning in clause 3 of this agreement.'
      },
      {
        description:
          '<b>Third Party Products</b> means software, products, services or content (including all Intellectual Property contained therein) that:',
        roman: true,
        details: [
          'are provided by third parties;',
          'interoperate with the Schedulized Platform; and/or',
          'may be identified as third party products.'
        ]
      },
      {
        description:
          '<b>Third Party Providers</b> means a supplier of Third Party Products. '
      },
      {
        description: '<b>User Account</b> has the meaning in clause 2.1.'
      },
      {
        description: '<b>User Data</b> has the meaning in clause 5.1(a).'
      },
      {
        description:
          '<b>User Password</b> has the meaning given to it by clause 2.1(a). '
      },
      {
        description:
          '<b>Redelec</b>, <b>we</b>, <b>our</b> or <b>us</b> means Redelec Services Pty Ltd (ACN 614 350 613), and where the context permits, includes our Personnel and Affiliates. '
      },
      {
        description:
          '<b>Website</b> refers to website accessible at [insert link to website]. '
      },
      {
        description:
          '<b>User</b>, <b>you</b> or <b>your</b> has the meaning in clause 1.3.'
      }
    ]
  }
]
